// extracted by mini-css-extract-plugin
module.exports = {"content-template":"Email_content-template__3JRo1","button-download-order":"Email_button-download-order__TAYt5","select-group":"Email_select-group__92e-s"};